import { createContext } from 'react'

import { TAiPageChatMessageDto, TPrototypePageDto, TPrototypePartialDto } from '@app-velocity/av-api-v2';
import { AIResponse } from '@app-velocity/common';

export type SingleAiResponseContextType = {
    stepNumber: number;
    collapsed?: boolean;
    message?: TAiPageChatMessageDto;
    response?: AIResponse | null;
    page?: TPrototypePageDto;
    partials?: TPrototypePartialDto[];
    analysing?: boolean;
    toggleCollapse?: () => void;
}

export const SingleAiResponseContext = createContext<SingleAiResponseContextType>({
    stepNumber: 0,
})